import React, {useEffect, useState} from 'react';

import Layout from './layout';
import {useParams} from "react-router";
import {getProjectDetail} from "~services/IIRSAProjectDetailService";

const IIRSAProjectDetail = (props) => {
    const {id} = useParams();
    const [state, setState] = useState({
        projectDetail: {},
        loading: true,
        openModal: false
    });
    useEffect(() => {
        getProjectDetail(id).then((response) => {
            setState({
                projectDetail: response.data,
                loading: false,
                openModal: false
            });
        });
    }, [id]);

    const {projectDetail, loading, openModal} = state;

    return (
        <Layout
            projectDetail={projectDetail}
            loading={loading}
            id={id}
            openModal={openModal}
        />
    );

}

export default IIRSAProjectDetail;
